<template>
  <div>
    <button class="transparent-btn" @click="read">
      查看
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  created() {},
  computed: {
    ...mapState({
      user: 'user',
    }),
  },
  methods: {
    read() {
      this.params.context.componentParent.openCardHandler(
        true,
        this.params.data,
      );
    },
  },
};
</script>

<style lang="scss" scoped></style>
